/**
 * URL参数处理工具函数
 */

export interface ResetPasswordParams {
  hasResetToken: boolean
  accessToken?: string
  refreshToken?: string
  error?: string
  errorDescription?: string
  isResetPasswordFlow?: boolean
}

/**
 * 检测URL中是否包含密码重置参数
 */
export const detectResetPasswordParams = (): ResetPasswordParams => {
  const urlParams = new URLSearchParams(window.location.search)
  const hasAccessToken = urlParams.has('access_token') || urlParams.has('token')
  const isResetPasswordFlow = urlParams.has('reset-password') && urlParams.get('reset-password') === 'true'

  return {
    hasResetToken: hasAccessToken || isResetPasswordFlow,
    accessToken: urlParams.get('access_token') || undefined,
    refreshToken: urlParams.get('refresh_token') || undefined,
    error: urlParams.get('error') || undefined,
    errorDescription: urlParams.get('error_description') || undefined,
    isResetPasswordFlow
  }
}

/**
 * 清除URL中的密码重置参数
 */
export const clearResetPasswordParams = (): void => {
  if (window.history && window.history.replaceState) {
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)

    // 移除所有密码重置相关的参数
    params.delete('access_token')
    params.delete('refresh_token')
    params.delete('token')
    params.delete('type')
    params.delete('error')
    params.delete('error_description')
    params.delete('reset-password')

    // 更新URL
    url.search = params.toString()
    window.history.replaceState({}, document.title, url.toString())
  }
}

/**
 * 验证重置令牌格式
 */
export const validateResetToken = (token?: string): boolean => {
  if (!token) return false

  // 基本长度验证（Supabase的token通常很长）
  if (token.length < 100) return false

  // Supabase token通常是JWT格式，包含3个部分
  const parts = token.split('.')
  if (parts.length !== 3) return false

  // 简单的base64验证（每个部分都应该是base64编码）
  try {
    parts.forEach(part => {
      // JWT的每个部分应该是base64编码的（可能包含填充）
      // 但不是严格的验证，因为有些实现可能不使用标准base64
      if (part.length === 0) return false
    })
    return true
  } catch {
    return false
  }
}